import React from 'react';
import {style} from './footerStyles';
import { Link } from 'react-router-dom';

const Footer = () => (
    <div className={style}>
        <div style={{width: '100%', textAlign:'center'}}>
            <div>
        <Link to="/privacy-policy">Privacy Policy</Link> |  <Link to="/terms-and-conditions">Terms and Conditions</Link>|  <Link to="/contact-us">Contact Us</Link>
        </div>
        </div>
   <div style={{textAlign:'center', paddingTop: '10px'}}> Copyright &copy; {new Date().getFullYear()}. Thunder Dofollow Social Bookmarking </div> 
   
</div>
);

export { Footer };